import FlatPlacementSelect from './FlatPlacementSelect';

export default FlatPlacementSelect;
